/**
 * Constants + helpers shared by the ManageColumns composition.
 *
 * Kept separate from the React components so the StudyPage can re-use the
 * helpers (column-id namespacing, storage keys) without pulling the
 * component tree into its own bundle graph.
 */

/** Column type discriminator for panel properties. */
export const PANEL_PROPERTY_TYPE = 'panel_property';
export const PANEL_PROPERTY_TYPE_LABEL = 'Panel Property';

/** String prefix used when namespacing `tableColumns_all` ids for panel properties. */
export const PANEL_PROPERTY_COLUMN_PREFIX = 'panel_property_';

/** Labels shown above column titles (in the NiceDropdown + modal headers). */
export const STUDY_PROPERTY_SUBLABEL = 'Study Property';
export const CUSTOM_VARIABLE_SUBLABEL = 'Custom Variable';
export const screenerSubLabel = title => `Screener: ${title}`;

/**
 * Compose a table-column id for a panel property id.
 *
 * @param {number|string} propertyId
 * @returns {string} e.g. "panel_property_42"
 */
export const namespaceColumnId = propertyId => `${PANEL_PROPERTY_COLUMN_PREFIX}${propertyId}`;

/**
 * Recover the numeric panel property id from a namespaced column id.
 *
 * @param {string} columnId
 * @returns {number|null}
 */
export const parsePanelPropertyColumnId = columnId => {
    if (!columnId || !columnId.startsWith(PANEL_PROPERTY_COLUMN_PREFIX)) return null;
    const id = Number(columnId.slice(PANEL_PROPERTY_COLUMN_PREFIX.length));
    return Number.isFinite(id) ? id : null;
};

/**
 * LocalStorage key for the user's panel-property subscription per study.
 *
 * Stores the set of panel property ids that the user has "added" to this
 * study's column set via the ManageColumns modal.
 */
export const panelPropertiesStorageKey = studyId => `pfx_study_panel_properties:${studyId}`;
